import React from "react";
import Card from "react-bootstrap/Card";
import ButtonMailto from "../ButtonMailto";
import { ImPhone, ImMail3, ImLocation } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify", color: "#979797" }}>
            We are an entertain, artist-driven talent agency Found in 2021, based in Jakarta. Your solution for: Wedding, Events, Birthday Party, Corporate/private parties, etc. We entertain your guests with soulful, melodies and romantic wedding songs performed with all music genres.
          <br/><br/>
            <li className="about-activity">
              <ImPhone size={40} /> {" - "} 
              <a
                href="https://api.whatsapp.com/send/?phone=6287772787447&text&app_absent=0"
                style={{ color: "#979797" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
              08-777-278-7447
              </a>
            </li>
            <br/>
            <li className="about-activity" >
              <ImMail3 size={40}  /> {" - "} <ButtonMailto label="songofsongs.entertainment@gmail.com" mailto="mailto:songofsongs.entertainment@gmail.com" />
            </li>
            <br/>
            <li className="about-activity">
              <ImLocation size={40} /> {" - "} 
              <a
                href="https://goo.gl/maps/kgScA6VoTg6LdhH59"
                style={{ color: "#979797" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
              Permata Depok Regency, Cluster Ruby, Blok D1, No.15, Jawa Barat 16439
              </a>
            </li>
          </p>
          
          {/* <br/><br/>
          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Exercitation Lorem id ea amet irure est consectetur sunt."{" "}
          </p>
          <footer className="blockquote-footer">Song of Songs</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
